<template>
	<div>
		<div class="d-flex flex-row align-items-center">
		<div>
			<content-hover :user="user" avatar />
		</div>
		<div class="pl-4">
			<content-hover :user="user" hover-class="bold font-14 my-auto" />
			<div class="font-12 font-weight-bold grey--text pt-1">
				{{ user.job_position }}
			</div>
		</div>
		<v-btn :to="{name: 'Profile', params: {
			userID: user.id
		}}"
		class="ml-auto" elevation="0">Przejdź do profilu</v-btn>
	</div>
	</div>
	
</template>

<script>
import ContentHover from "@/components/items/ContentHover"
export default {
	name: "SearchResultsUser",
	components: {
		ContentHover
	},
	props: {
		user: {
			type: Object,
			required: true
		}
	}
}
</script>
